export const addCustomFieldsInFormData = (formData, issueData) => {
    if (Array.isArray(issueData.custom_fields)) {
        issueData.custom_fields.forEach((field) => {
            for (const key in field) {
                formData.append(`custom_fields[${key}]`, field[key]);
            }
        });
    }
    else {
        for (const key in issueData.custom_fields) {
            formData.append(`custom_fields[${key}]`, issueData.custom_fields[key]);
        }
    }
};
